module.exports = __webpack_public_path__ + "population-percentile-cut-points.739f2d5be5eed6c157cd1321303a028a.png";